import { render, staticRenderFns } from "./ProductInfoForm.vue?vue&type=template&id=b61e5f7c&scoped=true"
import script from "./ProductInfoForm.vue?vue&type=script&lang=ts"
export * from "./ProductInfoForm.vue?vue&type=script&lang=ts"
import style0 from "./ProductInfoForm.vue?vue&type=style&index=0&id=b61e5f7c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61e5f7c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b61e5f7c')) {
      api.createRecord('b61e5f7c', component.options)
    } else {
      api.reload('b61e5f7c', component.options)
    }
    module.hot.accept("./ProductInfoForm.vue?vue&type=template&id=b61e5f7c&scoped=true", function () {
      api.rerender('b61e5f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/product/components/ProductInfoForm.vue"
export default component.exports